import { useTranslation } from "react-i18next"
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader"
import DarkCard from "../../../../../../../../components/card/DarkCard"
import LightCard from "../../../../../../../../components/card/LightCard"
import {Link, useParams} from "react-router-dom";
import MenuButtons from "../MenuButtons";
import Error404 from "../../../../../../../Error404";
import React, { useState } from "react";
import { useEffect } from "react";
import Rates from "./Rates";
import { Events } from "./Events";
import { TxtTitles } from "../../../../../../../../helpers/breadCrumbs";
import styled from "styled-components";
import { Button } from "../../../../../../../../components/ui/Button";
import { Colors } from "../../../../../../../../components/theme";
import FeedsList from "../../FeedsList";
import { AdditionalProjectCosts } from "./AdditionalProjectCosts";
import {useEndpoint} from "../../../../../../../../hooks/useEndpiont";
import {projectCurrent} from "../../../../../../../../services/api/endpoints";
import LoadingData from "../../../../../../../LoadingData";


const TotalPriceStyle = styled.p`
	font-size: 1.5rem;
	font-weight: bold;
	width: 100%;
	@media (max-width: 575px) {
		font-size: 1.8rem;
	}
`;


const SummaryView = () => {
	const params = useParams()
	const [{data, loading, error}] = useEndpoint(projectCurrent.summaryViewData(params.id))
	const {t} = useTranslation()
	const [rates, setRates] = useState({})
	const [events, setEvents] = useState([])
	const [events_original, setEvents_original] = useState([])
	const [additional_musicians, setAdditionalMusicians] = useState([])
    const [usersList, setUsersList] = useState([])
	const [late_arrival_fee_deduction, setLate_arrival_fee_deduction] = useState(0.00)
    const [persons_events, setPersonsEvents] = useState([])

    useEffect(() => {
		if (data) {
			setRates(data.rates)
			setEvents(data.events)
			setEvents_original(data.events)
			setPersonsEvents(data.persons)
			setUsersList(data.users_list)
			setLate_arrival_fee_deduction(data.late_arrival_fee_deduction)
			setAdditionalMusicians(data.additional_musicians)
		}
    }, [data])

	if (loading) return <LoadingData/>
	if (error) return <Error404/>

	const summary_cost = () => {
		const sum_cost = {client_cost: 0, estro_cost: 0, grant_cost: 0, total: 0};

		events.forEach(event => {
			const sum_client_estro_cost = event.musicians.reduce((m_sum, musician) => {
				m_sum.client_cost += +musician.client_cost
				m_sum.estro_cost += +musician.estro_cost
				return m_sum;
			}, {client_cost: 0, estro_cost: 0});

			sum_cost.client_cost += +sum_client_estro_cost.client_cost
			sum_cost.estro_cost += +sum_client_estro_cost.estro_cost
		})

		sum_cost.grant_cost = sum_cost.estro_cost - sum_cost.client_cost >= 0
			? parseFloat(sum_cost.estro_cost).toFixed(2)
			: parseFloat("0.00").toFixed(2)

		sum_cost.total =  sum_cost.client_cost >= sum_cost.estro_cost
			? parseFloat(sum_cost.client_cost).toFixed(2)
			: parseFloat(sum_cost.estro_cost).toFixed(2)

		return sum_cost;
	}
	const get_summary_costs = summary_cost()

    return (<>
		<DarkCard classNames='mb-3 row'>
			<p className="m-0 p-0 breadcrumbs">
				<span className="txt">{t("menu.projects",{ ns: 'menu' })}</span> &#9656;
				<Link to={'/projects/currents-list'}>{t("menu.current_projects",{ ns: 'menu' })}</Link> &#9656;
				<Link to={'/projects/current/'+params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>
			</p>
		</DarkCard>

		<DarkCard classNames='mb-3 row'>
			<TxtTitles>{t("project.project_name_title")}</TxtTitles>
			<h1 className='mb-0 mt-0 p-0' style={{marginTop: '-5px'}}>
				{/*state.dataset.name*/}
			</h1>
			<p className="mt-3 ps-0" style={{fontSize:'14px'}}>
				{t("project.project_id_title")} P{params.id}
			</p>

			<MenuButtons projectId={params.id} active={{summary: "active"}}/>

			<div className='mb-3 mt-5 px-0'>
				<Rates dataSet={rates}/>
			</div>

			<div className='mb-3 mt-3 px-0'>
				<Events
					events={events}
					setEvents={setEvents}
					events_original={events_original}
					pers={persons_events}
					usersList={usersList}
					late_arrival_fee_deduction={late_arrival_fee_deduction}
				/>
			</div>

			{/* Events musicians costs */}
			<LightCard classNames='mb-3 mt-3'>
				<RedHeader title={t("events.summary.event_mus_costs_title")} />
				<div className='row px-2'>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.clients_costs")}</u>
						</p>
						<TotalPriceStyle>
							{get_summary_costs.client_cost} €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estros_costs")}</u>
						</p>
						<TotalPriceStyle>{get_summary_costs.estro_cost} €</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estro_grant")}</u>
						</p>
						<TotalPriceStyle>
							{get_summary_costs.grant_cost} €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.total_costs")}</u>
						</p>
						<TotalPriceStyle>{get_summary_costs.total} €</TotalPriceStyle>
					</div>
				</div>
			</LightCard>

			{/* Renting & Transport */}

			{/* Administration & Archiving */}

			{/* Additional musicians costs */}

			{/* Additional project costs */}

			<div className='mb-3 mt-3 px-0'>
				{additional_musicians.length > 0 &&
					<AdditionalProjectCosts additional_musicians={additional_musicians} />
				}
			</div>

			{/* Total */}
			<LightCard classNames='mb-3 mt-3'>
				<RedHeader title={t("events.summary.total_title")} />
				<div className='row px-2'>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.clients_costs")}</u>
						</p>
						<TotalPriceStyle>
							WPISAC €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estros_costs")}</u>
						</p>
						<TotalPriceStyle>WPISAC €</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estro_grant")}</u>
						</p>
						<TotalPriceStyle>
							WPISAC €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.total_costs")}</u>
						</p>
						<TotalPriceStyle>WPISAC €</TotalPriceStyle>
					</div>
				</div>
			</LightCard>

			<div className='mb-3 mt-5 px-0'>
				<Button
					className='me-4 pull-right'
					variant='round'
					style={{ backgroundColor: Colors.magenta }}
					name='invoice'
					onClick={() => {}}>
					{t("common.button.create_invoice")}
				</Button>
			</div>
		</DarkCard>

		<DarkCard classNames='mb-3 row'>
			{/* FEED */}
			<FeedsList projectID={params.id}/>
		</DarkCard>
    </>)
}


export default SummaryView

